import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';

export interface ParamedNavigationExtras extends NavigationExtras {
  params: { [key: string]: any };
}

@Injectable()
export class RouterService {
  public routerParams: { [key: string]: any };

  public constructor(
    private router: Router,
  ) {
  }

  public async navigateByUrl(url: string | UrlTree, extras: ParamedNavigationExtras = {params: {}}): Promise<boolean> {
    this.set(extras.params);
    delete extras.params;
    return this.router.navigateByUrl(url, extras);
  }

  public get(param: string): any {
    if (this.routerParams) {
      return this.routerParams[param];
    }
    return undefined;
  }

  public set(data: { [key: string]: any }): void {
    this.routerParams = data;
  }

  isActive(link: string) {
    const target = location.origin + '/' + link;
    const current = location.href;
    // const active = current === target;
    // console.log('act: ', active);
    return current === target;
  }

}
